export default __webpack_public_path__ + "static/media/active_orders.a5717aae.svg";